import { useState } from "react"
import dateComponent from "../../components/dateComponent"
import Vista from "../../components/Vista"
import TableCustom from "../../components/TableCustom"

const busquedaDefault = {
  fechaInicio: dateComponent.getFirstDayOfYear(),
  fechaFinal: dateComponent.getActualDay()
}

const dataTable = {
  proyecto: { nombre: "Proyecto", content: (asignacion) => (asignacion.proyecto || asignacion.area)?.nombre || "—" },
  ubicacion: { nombre: "Ubicación", content: (asignacion) => (asignacion.proyecto || asignacion.area)?.ubicacion || "—" },
  economico: { nombre: "No. económico", content: (asignacion) => asignacion.carro?.economico || "—" },
  carro: {
    nombre: "Carro",
    content: (asignacion) =>
      [asignacion.carro?.marca, asignacion.carro?.modelo, asignacion.carro?.year]
        .filter(Boolean)
        .join(" ") || "—"
  },
  placas: { nombre: "Placas", content: (asignacion) => asignacion.carro?.placas || "—" }
}

const CarrosAreas = () => {
  const [busqueda, setBusqueda] = useState({ ...busquedaDefault })

  return (
    <Vista>
      <TableCustom
        tipo="idProyecto"
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        dataTable={dataTable}
        dataPdf={dataTable}
        permisoCheck="carrosAreas"
        nombreBusqueda={["proyecto.nombre", "proyecto.ubicacion"]}
        expand="proyecto,carro"
        addLabel="Asignar carro"
        Actions={false}
      />
    </Vista>
  )
}

export default CarrosAreas
